// This is used to decide if the submenu should be active
export const isUrlMatch = (pathname: string | null, href: string | RegExp) => {
  if (!pathname) {
    return false;
  }
  if (href instanceof RegExp) {
    return href.test(pathname);
  }
  return pathname === href;
};

export const isActiveOverriden = (
  pathname: string | null,
  activeUrls?: (string | RegExp)[]
) => {
  if (!pathname || !activeUrls?.length) {
    return false;
  }
  const cleanPathname = pathname.split('?')[0].split('#')[0];
  return activeUrls.some((pattern) => {
    if (pattern instanceof RegExp) {
      return pattern.test(cleanPathname);
    }
    return pattern === cleanPathname;
  });
};
